import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type FilmIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

// Design Library · Foundation → Iconography → "film" (node 941:2401). Drawn on a
// 20×20 frame with the glyph inset 8.33% (translate 0.9167), stroke 1.5, round caps.
export const FilmIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: FilmIconProps) => {
  const resolvedColor =
    color ??
    tokenVar(
      colorScheme === 'light'
        ? 'colors.light.icon.secondary'
        : 'colors.icon.secondary'
    )
  return (
    <svg
      aria-label='Film'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 20 20'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.91667 0.75V17.4167M13.25 0.75V17.4167M0.75 9.08333H17.4167M0.75 4.91667H4.91667M0.75 13.25H4.91667M13.25 13.25H17.4167M13.25 4.91667H17.4167M2.56667 0.75H15.6C16.6033 0.75 17.4167 1.56335 17.4167 2.56667V15.6C17.4167 16.6033 16.6033 17.4167 15.6 17.4167H2.56667C1.56335 17.4167 0.75 16.6033 0.75 15.6V2.56667C0.75 1.56335 1.56335 0.75 2.56667 0.75Z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        transform='translate(0.9167 0.9167)'
      />
    </svg>
  )
}
